import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import logo from '../assets/images/logo.png';
import axios from 'axios';
import apiInstance from './apiInstance';
import {changeCurrentUser, changeThemeMode} from '../state/actionCreators/index'

class Navbar extends Component {
    
    toggleDropdown = () => {
        document.getElementById('profile-dd-content').classList.toggle('mjs-hidden');
    };

    handleSignOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');

        sessionStorage.removeItem('userSwitched');
        sessionStorage.removeItem('adminId');
        sessionStorage.removeItem('adminToken');
        window.location.href = '/';
    }

    toggleTheme = () => {
        const newIsDark = !this.props.isDark;
        this.props.changeThemeMode(newIsDark);
        localStorage.setItem('darkMode', String(newIsDark));
        if (Object.keys(this.props.user).length !== 0) {
            apiInstance.patch('/user/preferences', { darkMode: newIsDark })
                .catch(err => console.error('Theme save error', err));
        }
    }

    switchBackToAdmin = () => {

        const userSwitched = sessionStorage.getItem("userSwitched");
        if(userSwitched === "true") {
            const adminId = sessionStorage.getItem("adminId");
            const adminToken = sessionStorage.getItem("adminToken");

            const baseURL = process.env.REACT_APP_SERVER_URL;

            axios.get(`${baseURL}/devadmin/user/switch/${adminId}`, {
                headers: {
                    Authorization: `Bearer ${adminToken}`
                }
            })
            .then(response => {
                const user = response.data.user;

                localStorage.setItem('token', user.token);
                localStorage.setItem('userId', user.id);

                sessionStorage.removeItem('adminToken');
                sessionStorage.removeItem('adminId');
                sessionStorage.setItem('userSwitched', false);

                this.props.changeCurrentUser(user)
                window.location.href = "/devadmin";
                
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        }
    }

    render() {
        let isLoggedIn = false;
        const user = this.props.user;
        let userDisplayName = '';

        if (Object.keys(user).length !== 0) {
            isLoggedIn = true;
            userDisplayName = user.name;
        }

        let userSwitched = isLoggedIn && sessionStorage.getItem("userSwitched");

        return (
            <div className="mjs-navbar">
                <div className="mjs-navbar-title">
                    <Link to="/websites">
                        <img src={logo} className="mjs-logo" />
                    </Link>
                </div>
                <div className="mjs-navbar-links">

                    <div
                        className="mjs-nav-link"
                        onClick={this.toggleTheme}
                        style={{cursor:'pointer'}}
                        title={this.props.isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                    >
                        <i className={this.props.isDark ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}></i>
                    </div>

                    {
                        (isLoggedIn && user.role === 'admin') &&
                        <Link className="mjs-nav-link" to="/devadmin">Backend Admin</Link>
                    }

                    <div onClick={this.switchBackToAdmin} className={`mjs-nav-link` + (userSwitched === 'true' ? '' : ' mjs-hidden' )} style={{cursor:'pointer'}}>Switch back to admin</div>
                    {
                        (isLoggedIn) ?
                        <>
                            <Link className="mjs-nav-link" to="/websites"> Dashboard </Link>
                        </>
                        :
                        ''
                    }
                    {
                        (isLoggedIn)
                            ? (
                                <div className="mjs-nav-link" onClick={this.toggleDropdown}>
                                     <div className="profile-dd"><i className="fa-regular fa-circle-user "></i>{userDisplayName}</div>

                                    <div id="profile-dd-content" className="mjs-dropdown-content mjs-hidden">
                                        
                                        <Link to="/account">
                                            <div className='mjs-dropdown-item'>
                                            <i class="fa-solid fa-user-pen"></i> Edit Profile
                                        </div>
                                        </Link>

                                        <div className='mjs-dropdown-item' onClick={this.handleSignOut}>
                                            <span> <i class="fa-solid fa-arrow-right-from-bracket"></i> Sign Out </span>
                                        </div>
                                    </div>

                                </div>
                            )
                            : (<></>)
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
            isDark: state.theme,
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return (
      {
        changeCurrentUser: (user) => { dispatch(changeCurrentUser(user)) },
        changeThemeMode: (isDark) => { dispatch(changeThemeMode(isDark)) },
      }
    )
}
export default connect(mapStateToProps,mapDispatchToProps )(Navbar);
